import { Core } from '@synergy/microfrontend_core';
import i18next from 'i18next';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from "react-query";
import { Routes } from "./components/App/Routes/Routes";
import query from './server/constants.api';

export const pagesConfiguration = [
  {
    tabName: "inicio",
    tabIcon: null,
    id: "home",
    path: "/home",
    filters: false,
  },
  {
    tabName: "Buildings",
    tabIcon: null,
    id: "buildings",
    path: "/buildings",
    filters: false,
  },
  {
    tabName: "map",
    tabIcon: null,
    id: "map",
    path: "/map",
    filters: true,
  },
  {
    tabName: "registry",
    tabIcon: null,
    id: "registry",
    path: "/registry",
    filters: false,
  },
  {
    tabName: "events",
    tabIcon: null,
    id: "events",
    path: "/events",
    filters: false,
  },
  {
    tabName: "analytics",
    tabIcon: null,
    id: "analytics",
    path: "/analytics",
    filters: false,
  },
  {
    tabName: "configurations",
    tabIcon: null,
    id: "configurations",
    path: "/configurations",
    filters: false,
  }
  // {
  //     tabName: "politicas",
  //     tabIcon: null,
  //     id: "policies",
  //     path: "/home/politics/CIRIS",
  //     subMenu: [{
  //         name: "Energia e Emissões",
  //         path: "/home/politics/CIRIS",
  //         submenus: null
  //     },
  //         // {
  //         //     name: "Certificado energético",
  //         //     path: "/home/politics/energeticCertficate",
  //         //     submenus: null
  //         // }
  //     ],
  //     filters: false
  // }
];

const queryClient = new QueryClient();

function UnifiedBuildings() {

  useEffect(() => {
    const handler = (e) => {
      if (i18next.resolvedLanguage !== e.detail.lng) {
        i18next.changeLanguage(e.detail.lng);
      }
    };
    window.addEventListener("languageChanged", handler);
    return () => window.removeEventListener("languageChanged", handler);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Core pagesConfiguration={pagesConfiguration} query={query}>
        <Routes />
      </Core>
    </QueryClientProvider>
  );
}

export default UnifiedBuildings;
